import React, {Component} from 'react';
import styled from 'styled-components';
import Input from '../../components/Input';

const MAX_WIDTH = 5;
const MAX_HEIGHT = 10;

class NumericGridBuilder extends Component {
  state = {
    width: this.props.gridWidth || 2,
    height: this.props.gridHeight || 2,
    inputWidth: this.props.gridWidth || 2,
    inputHeight: this.props.gridHeight || 2,
    widthError: false,
    heightError: false
  };

  handleWidthChange = e => {
    const inputValue = parseInt(e.target.value) || 1;
    const isError = inputValue > MAX_WIDTH;
    const actualWidth = Math.min(inputValue, MAX_WIDTH);

    this.setState({
      inputWidth: inputValue,
      width: actualWidth,
      widthError: isError
    });

    this.props.onChange({width: actualWidth, height: this.state.height});
  }

  handleHeightChange = e => {
    const inputValue = parseInt(e.target.value) || 1;
    const isError = inputValue > MAX_HEIGHT;
    const actualHeight = Math.min(inputValue, MAX_HEIGHT);

    this.setState({
      inputHeight: inputValue,
      height: actualHeight,
      heightError: isError
    });

    this.props.onChange({width: this.state.width, height: actualHeight});
  }

  render() {
    const {width, height, inputWidth, inputHeight, widthError, heightError} = this.state;
    const {questionText} = this.props;

    return (
      <Container>
        <GridHeader>Grid Configuration</GridHeader>
        <GridInputs>
          <GridInputWrapper>
            <LabelRow>
              <label>Width (columns):</label>
              <MaxLabel>Max: {MAX_WIDTH}</MaxLabel>
            </LabelRow>
            <StyledInput
              type="number"
              min="1"
              max={MAX_WIDTH}
              value={inputWidth}
              onChange={this.handleWidthChange}
              error={widthError}
            />
            {widthError && (
              <ErrorMessage>Maximum width is {MAX_WIDTH}. Showing {MAX_WIDTH} columns.</ErrorMessage>
            )}
          </GridInputWrapper>
          <GridInputWrapper>
            <LabelRow>
              <label>Height (rows):</label>
              <MaxLabel>Max: {MAX_HEIGHT}</MaxLabel>
            </LabelRow>
            <StyledInput
              type="number"
              min="1"
              max={MAX_HEIGHT}
              value={inputHeight}
              onChange={this.handleHeightChange}
              error={heightError}
            />
            {heightError && (
              <ErrorMessage>Maximum height is {MAX_HEIGHT}. Showing {MAX_HEIGHT} rows.</ErrorMessage>
            )}
          </GridInputWrapper>
        </GridInputs>
        <PreviewContainer>
          <PreviewLabel>Preview ({width}x{height} = {width * height} questions):</PreviewLabel>
          <FormPreview>
            {questionText && <QuestionTitle>{questionText}</QuestionTitle>}
            <GridPreview width={width} height={height}>
              {Array.from({length: height}, (_, row) => (
                <GridRow key={row}>
                  {Array.from({length: width}, (_, col) => (
                    <GridCell key={`${row}-${col}`}>
                      <NumericInput />
                    </GridCell>
                  ))}
                </GridRow>
              ))}
            </GridPreview>
          </FormPreview>
        </PreviewContainer>
      </Container>
    );
  }
}

const Container = styled.div`
  padding: 1rem;
  background: #f5f5f5;
  border-radius: 4px;
  margin: 1rem 0;
`;

const GridHeader = styled.h4`
  margin: 0 0 1rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
`;

const GridInputs = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const GridInputWrapper = styled.div`
  flex: 1;

  label {
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    color: #666;
  }
`;

const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
`;

const MaxLabel = styled.span`
  font-size: 0.75rem;
  color: #999;
  font-style: italic;
`;

const StyledInput = styled(Input)`
  ${props => props.error && `
    border-color: #dc3545;
    background-color: #fff5f5;

    &:focus {
      border-color: #dc3545;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }
  `}
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const PreviewContainer = styled.div`
  margin-top: 1rem;
`;

const PreviewLabel = styled.div`
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.5rem;
`;

const FormPreview = styled.div`
  padding: 1rem;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  max-width: 300px;
`;

const QuestionTitle = styled.h4`
  margin: 0 0 0.75rem 0;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
`;

const GridPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const GridRow = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

const GridCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 40px;
`;

const NumericInput = styled.div`
  width: 30px;
  height: 20px;
  border: none;
  border-bottom: 1px solid #666;
  background: transparent;
  position: relative;
`;

export default NumericGridBuilder;